'use client';

import { type ReactNode, useEffect } from 'react';
import { useHeaderActions } from './header-actions-context';

export function SetHeaderActions({ children }: { children: ReactNode }): null {
  const { setActions } = useHeaderActions();

  useEffect(() => {
    setActions(children);
    return () => setActions(null);
  }, [children, setActions]);

  return null;
}
